
import * as Price from "./price";

const currentLanguage = document.documentElement.getAttribute("lang");
const frequencyEls = document.querySelectorAll("[name=frequency]");
const frequencyMobileCheckEl = document.getElementById("year-month-checkbox");
const radioYearEl = document.getElementById("radio-year");
const radioMonthEl = document.getElementById("radio-month");
const surgerySliderEl = document.getElementById("surgery");
const storeSliderEl = document.getElementById("store");
const tarifStarterButtonSettingsEl = document.getElementById("tarifStarterButtonSettings");
const tarifProfiButtonSettingsEl = document.getElementById("tarifProfiButtonSettings");

const starterPriceEl = document.getElementById("starterPrice");
const totalStarterPriceEl = document.getElementById("totalStarterPrice");
const totalStarterPriceWithVatEl = document.getElementById("totalStarterPriceWithVat");

const profiPriceEl = document.getElementById("profiPrice");
const totalProfiPriceEl = document.getElementById("totalProfiPrice");
const totalProfiPriceWithVatEl = document.getElementById("totalProfiPriceWithVat");

const surgeryPriceEl = document.getElementById("surgeryPrice");
const totalSurgeryPriceEl = document.getElementById("totalSurgeryPrice");
const totalSurgeryPriceWithVatEl = document.getElementById("totalSurgeryPriceWithVat");
const surgeryLabelEl = document.querySelector("label[for='surgery']")

const storePriceEl = document.getElementById("storePrice");
const totalStorePriceEl = document.getElementById("totalStorePrice");
const totalStorePriceWithVatEl = document.getElementById("totalStorePriceWithVat");
const storeLabelEl = document.querySelector("label[for='store']");

const totalMonthPriceWithoutVatEl = document.getElementById("totalMonthPriceWithoutVat");
const totalYearPriceWithoutVatEl = document.getElementById("totalYearPriceWithoutVat");
const totalYearPriceWithVatEl = document.getElementById("totalYearPriceWithVat");

const storeNumberPlaceholderEls = document.querySelectorAll("[data-id=storeNumberPaceholder]");
const surgeryNumberPlaceholderEls = document.querySelectorAll("[data-id=surgeryNumberPaceholder]");
const tarifLabelEls = document.querySelectorAll("[data-id=tarifLabelPlaceholder]");
const tarifButtonPlaceholder = document.querySelectorAll("[data-id=tarifButtonPlaceholder]");

const surgeryWithPlural = surgeryLabelEl ? surgeryLabelEl.dataset.tokens.split("|") : null;
const warehouseWithPlural = storeLabelEl ? storeLabelEl.dataset.tokens.split("|") : null;

const tryStarterButtonText = tarifStarterButtonSettingsEl ? tarifStarterButtonSettingsEl.dataset.token : null;
const tryProfiButtonText = tarifProfiButtonSettingsEl ? tarifProfiButtonSettingsEl.dataset.token : null;

const starterSaleAmountEl = document.getElementById("starterSaleAmount");
const starterSalePercentageEl = document.getElementById("starterSalePercentage");
const profiSaleAmountEl = document.getElementById("profiSaleAmount");
const profiSalePercentageEl = document.getElementById("profiSalePercentage");
const surgerySaleAmountEl = document.getElementById("surgerySaleAmount");
const surgerySalePercentageEl = document.getElementById("surgerySalePercentage");
const storeSaleAmountEl = document.getElementById("storeSaleAmount");
const storeSalePercentageEl = document.getElementById("storeSalePercentage");

export function calculator() {
	surgerySliderEl.addEventListener("input", function() {
		changePrices();
	});

	storeSliderEl.addEventListener("input", function() {
		changePrices();
	});

	frequencyEls.forEach(el => {
		el.addEventListener("change", function() {
			changePrices();
		})
	});

	frequencyMobileCheckEl.addEventListener("click", function() {
		radioYearEl.checked = this.checked !== false;
		radioMonthEl.checked = this.checked === false;
		changePrices();
	})

	changePrices();
}

function changePrices() {
	Price.showPrice(starterPriceEl, Price.getPriceWithDiscount(Price.getMonthTarifPrice(1)));
	Price.showPrice(totalStarterPriceEl, Price.getTotalYearPrice(1, 1, 1));
	Price.showPrice(totalStarterPriceWithVatEl, Price.getTotalYearPriceWithVat(1, 1, 1));

	Price.showPrice(profiPriceEl, Price.getPriceWithDiscount(Price.getMonthTarifPrice(5)));
	Price.showPrice(totalProfiPriceEl, Price.getTotalYearPrice(5, 1, 1));
	Price.showPrice(totalProfiPriceWithVatEl, Price.getTotalYearPriceWithVat(5, 1, 1));

	Price.showPrice(surgeryPriceEl, Price.getPriceWithDiscount(Price.getMonthSurgeryPrice(surgerySliderEl.value)));
	Price.showPrice(totalSurgeryPriceEl, Price.getPayingMonths() * Price.getMonthSurgeryPrice(surgerySliderEl.value));
	Price.showPrice(totalSurgeryPriceWithVatEl, Price.getPriceWithVat(Price.getPayingMonths() * Price.getMonthSurgeryPrice(surgerySliderEl.value)));

	Price.showPrice(storePriceEl, Price.getPriceWithDiscount(Price.getMonthStorePrice()));
	Price.showPrice(totalStorePriceEl, Price.getPayingMonths() * Price.getMonthStorePrice());
	Price.showPrice(totalStorePriceWithVatEl, Price.getPriceWithVat(Price.getPayingMonths() * Price.getMonthStorePrice()));

	Price.showPrice(totalMonthPriceWithoutVatEl, Price.getTotalMonthPrice(surgerySliderEl.value, storeSliderEl.value));
	Price.showPrice(totalYearPriceWithoutVatEl, Price.getTotalYearPrice(surgerySliderEl.value, storeSliderEl.value));
	Price.showPrice(totalYearPriceWithVatEl, Price.getTotalYearPriceWithVat(surgerySliderEl.value, storeSliderEl.value));

    Price.showPrice(starterSaleAmountEl, Price.getMonthTarifPrice(1));
    Price.showSalePercentage(starterSalePercentageEl, Price.getDiscountAmount());
    Price.showPrice(profiSaleAmountEl, Price.getMonthTarifPrice(5));
    Price.showSalePercentage(profiSalePercentageEl, Price.getDiscountAmount());
    Price.showPrice(surgerySaleAmountEl, Price.getMonthSurgeryPrice(4));
    Price.showSalePercentage(surgerySalePercentageEl, Price.getDiscountAmount());
    Price.showPrice(storeSaleAmountEl, Price.getMonthStorePrice());
    Price.showSalePercentage(storeSalePercentageEl, Price.getDiscountAmount());

	for (let e of tarifLabelEls) {
		e.innerText = surgerySliderEl.value > 4 ? "Profi" : "Starter";
	}

	for (let e of tarifButtonPlaceholder) {
		e.value = surgerySliderEl.value > 4 ? tryProfiButtonText : tryStarterButtonText;
	}

	for (let e of surgeryNumberPlaceholderEls) {
		e.innerText = surgerySliderEl.value + " " + getPlural(surgerySliderEl.value, surgeryWithPlural);
	}

	for (let e of storeNumberPlaceholderEls) {
		e.innerText = storeSliderEl.value + " " + getPlural(storeSliderEl.value, warehouseWithPlural);
	}

}

function getPlural(num, variants) {
	if (num == 1) {
		return variants[0];
	} else if (num > 1 && num < 5) {
		return variants[1];
	} else {
		return variants[2];
	}
}
